import { Component, Input, SimpleChanges } from '@angular/core';
import { FirestoreService } from '../firestore-service.service';
import { Question } from '../container';
import { SharedServiceService } from '../shared-service.service';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-quiz',
    templateUrl: './quiz.component.html',
    styleUrls: ['./quiz.component.scss'],
    standalone: true,
    imports: [CommonModule, FormsModule],
})
export class QuizComponent {
  @Input() organizationKey = ""
  @Input() projectKey = ""
  @Input() userId = ""
  @Input() quizKey = ""
  @Input() quizName = ""  
  @Input() quizDescription = ""
  @Input() isReadOnly = false

  questions: Question[] = []
  goodAnswers = 0
  showResult = false
  isLoadingLabelVisible = false
  hideAnswered = false
  answeredQuestions = 0

  constructor(private firestore: FirestoreService, private service: SharedServiceService) {
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['quizKey']) {
      this.quizKey = changes['quizKey'].currentValue
      this.loadQuestions()
    }
  }

  ngAfterViewInit() {
    this.loadQuestions()
  }

  loadQuestions() {
    this.showResult = false
    this.goodAnswers = 0
    this.questions.length = 0
    if (this.organizationKey != undefined && this.organizationKey != "") {
      this.isLoadingLabelVisible = true
      this.firestore.getQuestionByQuiz(this.organizationKey, this.quizKey).then(result => {
        result.forEach(q => {
          this.questions.push(q.question)
        })
          this.isLoadingLabelVisible = false

      }).catch(() => {
        this.firestore.showSnackBar("I couldn't load quiz questions.")
        this.isLoadingLabelVisible = false
      })
    }
  }

  checkAnswer() {
    this.answeredQuestions += 1
  }

  checkAnswers() {
    this.goodAnswers = 0
    this.hideAnswered = false
    let i = 0
    this.questions.forEach(q => {
      if (q.correctAnswer == q.userSelected && q.correctAnswer != -1) {
        this.goodAnswers += 1
        i += 1
      }
      this.firestore.saveTestAnswers(this.organizationKey, this.projectKey, this.userId, this.questions[i])
      })
    this.showResult = true
    document.getElementById('topOfPage')?.scrollIntoView({ behavior: 'smooth' });
    window.scroll({ top: 0, left: 0, behavior: 'smooth' });
  }

  onSelect(qIndex: number, selectedIndex: number) {
    this.questions[qIndex].userSelected = selectedIndex;
  }

  toggleHideAnswered() {
    this.hideAnswered = !this.hideAnswered;
  }
}
